<cw-navigation-drawer *transloco="let t">
  <cw-navigation-drawer-section>
    <cw-button
      class="mr-auto mt-s mb-s"
      buttonColor="accent"
      [routerLink]="createOrderRoute"
      data-cy="nav-create-order-button">
      <cw-icon icon="create" font="cortex"/>
      {{ t('Create order') }}
    </cw-button>
    <a [routerLink]="ordersRoute" routerLinkActive #ordersLink="routerLinkActive"
      data-cy="orders-link-link">
      <cw-navigation-drawer-item
        icon="all_inbox"
        [label]="t('Orders')"
        [routerLink]="ordersRoute"
        [class.active]="ordersLink.isActive"
        font="material">
      </cw-navigation-drawer-item>
    </a>
  </cw-navigation-drawer-section>
  <cw-navigation-drawer-section>

    <a [routerLink]="helpRoute" routerLinkActive #helpLink="routerLinkActive"
      data-cy="help-link-link">
      <cw-navigation-drawer-item
        icon="help"
        [label]="t('Help')"
        [routerLink]="helpRoute"
        [class.active]="helpLink.isActive"
        font="material">
      </cw-navigation-drawer-item>
    </a>

   @if (userConfigsFacade.isAdminSignal()) {
     <a [routerLink]="settingsRoute" routerLinkActive #settingsLink="routerLinkActive"
       data-cy="settings-link-link">
       <cw-navigation-drawer-item
         icon="settings"
         [label]="t('Settings')"
         [routerLink]="settingsRoute"
         [class.active]="settingsLink.isActive"
         font="material">
       </cw-navigation-drawer-item>
     </a>
   }
  </cw-navigation-drawer-section>
</cw-navigation-drawer>
